import gsap from 'gsap';

const animationLeave = (container) => {
  //return gsap.to(container, { autoAlpha: 0, duration: 0.5, clearProps: 'all', ease: 'none'});
  //const main = document.querySelector('#main-content');
  const preloader = container.querySelector('.barbapreload');
  //const scrollContainer = document.querySelector('#scroll-container');
  // locomotive scroll works differently on mobile so ingore scroll container and use body instead
  //const body = document.querySelector('body');
  const pathOne = document.querySelector('.barbapreload svg path:nth-of-type(1)');
  const	pathTwo = document.querySelector('.barbapreload svg path:nth-of-type(2)');
  const	pathThree = document.querySelector('.barbapreload svg path:nth-of-type(3)');
  const	pathFour = document.querySelector('.barbapreload svg path:nth-of-type(4)');
  const	pathFive = document.querySelector('.barbapreload svg path:nth-of-type(5)');
  
  const tl = gsap.timeline({
    defaults: {
      duration: 0.2, 
      ease: 'power1.out'
    }
  });

  tl
    .to(preloader, {opacity: 1}, 0)
    //.to(main, {opacity: 0}, 0.50)
    //.to(scrollContainer, {y: 0}, 0.60)
    //.to(body, {y: 0}, 0.60)
    .fromTo(pathOne, {opacity: 0}, {opacity: 1}, 0.75)
    .fromTo(pathTwo, {opacity: 0}, {opacity: 1}, 1)
    .fromTo(pathThree, {opacity: 0}, {opacity: 1}, 1.25)
    .fromTo(pathFour, {opacity: 0}, {opacity: 1}, 1.50)
    .fromTo(pathFive, {opacity: 0}, {opacity: 1}, 1.75)

  return tl

}

export default animationLeave;